// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"c928369b","100":"c928369b","108":"c928369b","592":"26d16890","763":"c928369b","798":"c928369b","972":"c928369b","988":"f234e2e8"}[chunkId] + ".chunk.css";
};